import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account, PositivePayCheckFile } from "model";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import TASPositivePayImportChecksUsingTemplatePage from "components/pages/TASPositivePayImportChecksUsingTemplatePage";

/**
 * @name CapturePositivePayImportChecksImportErrors
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks" capture group.
 */
export default function CapturePositivePayImportChecksImportErrors(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    return <TASPositivePayImportChecksUsingTemplatePage />;
}